import React from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";

/**
 * Table header cell with optional sort toggle.
 */
const SortableTh = ({
  label,
  sortKey,
  activeKey,
  direction = "desc",
  onSort,
  className = "",
}) => {
  const sortable = Boolean(sortKey && onSort);
  const active = sortable && activeKey === sortKey;

  const handleClick = () => {
    if (sortable) onSort(sortKey);
  };

  return (
    <th
      className={`${sortable ? "ds-th-sortable" : ""} ${className}`.trim()}
      onClick={handleClick}
      aria-sort={
        active ? (direction === "asc" ? "ascending" : "descending") : "none"
      }
    >
      <span className="ds-th-inner">
        <span className="ds-th-label">{label}</span>
        {sortable && (
          <span className="ds-th-sort-icon" aria-hidden>
            {active ? (
              direction === "asc" ? (
                <ArrowUpwardIcon sx={{ fontSize: 14 }} />
              ) : (
                <ArrowDownwardIcon sx={{ fontSize: 14 }} />
              )
            ) : (
              <UnfoldMoreIcon sx={{ fontSize: 14 }} />
            )}
          </span>
        )}
      </span>
    </th>
  );
};

export default SortableTh;
